export const pricing2 = {
  navigation: {
    pricing: "Árazás",
    products: "Mit árulhatsz?",
    comparison: "Összehasonlítás",
    faq: "GYIK",
    login: "Bejelentkezés",
    freeStart: "Kezdd el ingyen",
    logoAlt: "Bespire logó"
  },
  hero: {
    title: "Kapj többet.\nFizess kevesebbet.",
    subtitle: "Nincsenek meglepetések: egyszerű és átlátható árazás.",
    commission: "4%",
    description: "Minden általunk lebonyolított értékesítésed után 4% + 120 Ft jutalék. Ha közvetlenül te kezeled a fizetést, nincs jutalék."
  },
  singlePackage: {
    badge: "Első 2 hét ingyenes",
    price: "10.000",
    currency: "",
    period: "Ft + ÁFA/hó",
    aiCredits: "100 AI kredit",
    aiCreditsNote: "induláskor",
    trialNote: "Próbáld ki 3 napig ingyen, kockázat nélkül",
    ctaButton: "Indítsd el most – ingyen",
    whyWorthIt: "Miért éri meg?",
    commissionNote: "Online fizetésnél 4% + 120 Ft jutalék. Helyszíni fizetésnél nincs jutalék.",
    benefits: [
      "Nincs rejtett költség",
      "Bármikor lemondhatod",
      "14 napos ingyenes próba",
      "100 AI kredit induláskor"
    ]
  },
  setupSection: {
    title: "Nincs időd beállítani? Megcsináljuk helyetted.",
    subtitle: "Egyetlen egyszeri díj, és a teljes rendszered készen áll — utána csak használod a havi csomagoddal.",
    badge: "Egyszeri díj",
    price: "50.000",
    currency: "",
    period: "Ft + ÁFA",
    ctaButton: "Indítsd el most – ingyen",
    benefits: [
      "Nincs rejtett költség",
      "Ingyenes első egyeztetés",
      "48 órán belüli válasz",
      "Elégedettségi garancia"
    ],
    features: [
      { text: "Teljes weboldal felépítése a te arculatoddal", icon: "Globe" },
      { text: "Termékek, szolgáltatások feltöltése", icon: "ShoppingBag" },
      { text: "Időpontfoglaló rendszer beállítása", icon: "Clock" },
      { text: "Fizetési rendszer konfigurálása", icon: "CreditCard" },
      { text: "Domain bekötés és technikai beállítások", icon: "Settings" },
      { text: "Induló marketing tartalmak elkészítése", icon: "TrendingUp" },
      { text: "Email marketing rendszer beállítása", icon: "Mail" },
      { text: "SEO optimalizálás és Google beállítások", icon: "Search" },
      { text: "Social media fiókok összekapcsolása", icon: "Users" },
      { text: "Személyes betanítás és átadás", icon: "UserCheck" }
    ],
    note: "Induló és már működő vállalkozásoknak egyaránt"
  },
  setupPackage: {
    badge: "Egyszeri díj",
    title: "Teljes beüzemelés",
    price: "50.000",
    currency: "",
    period: "Ft + ÁFA",
    subtitle: "Mi beállítjuk helyetted – te csak elindulsz",
    ctaButton: "Indítsd el most – ingyen",
    benefits: [
      "Nincs rejtett költség",
      "Ingyenes első egyeztetés",
      "48 órán belüli válasz",
      "Elégedettségi garancia"
    ],
    features: [
      { text: "Teljes weboldal felépítése a te arculatoddal", icon: "Globe" },
      { text: "Termékek, szolgáltatások feltöltése", icon: "ShoppingBag" },
      { text: "Időpontfoglaló rendszer beállítása", icon: "Clock" },
      { text: "Fizetési rendszer konfigurálása", icon: "CreditCard" },
      { text: "Domain bekötés és technikai beállítások", icon: "Settings" },
      { text: "Induló marketing tartalmak elkészítése", icon: "TrendingUp" },
      { text: "Email marketing rendszer beállítása", icon: "Mail" },
      { text: "SEO optimalizálás és Google beállítások", icon: "Search" },
      { text: "Social media fiókok összekapcsolása", icon: "Users" },
      { text: "Személyes betanítás és átadás", icon: "UserCheck" }
    ],
    note: "Induló és már működő vállalkozásoknak egyaránt"
  },
  enterprisePackage: {
    badge: "Pro",
    title: "Pro",
    subtitle: "Nagyobb csapatok és vállalkozások számára",
    priceLabel: "Egyedi árazás",
    priceSubtext: "Az igényeidre szabva",
    ctaButton: "Kérj ajánlatot",
    tabStandard: "Standard",
    tabPro: "Pro",
    highlights: [
      "Minden, ami a Standard csomagban",
      "Teljesen egyedi árazás",
      "Dedikált account manager",
      "24/7 elsőbbségi támogatás",
      "AI-asszisztens a napi munkádhoz",
      "Egyedi API integráció",
      "White-label megoldás",
      "Egyedi onboarding és képzés",
      "SLA garancia",
      "Többfelhasználós admin felület",
      "Korlátlan munkatárs kezelés",
      "Teljes GDPR megfelelés",
      "Priorizált fejlesztési kérések"
    ]
  },
  products: {
    title: "Ezt kapod:",
    packagesTitle: "",
    aiCredits: {
      free: {
        title: "AI kredit",
        subtitle: ""
      },
      paid: {
        title: "Havi AI kredit",
        subtitle: ""
      }
    },
    starterItems: [
      "Teljes weboldal létrehozása AI asszisztenssel",
      "AI-vezérelt időpontfoglaló rendszer automatikus emlékeztetőkkel",
      "Digitális termékek értékesítése",
      "Online kurzusok értékesítése",
      "Egyéni vagy csoportos órák értékesítése",
      "Csoportos workshopok szervezése",
      "Bérletek és tagságok kezelése",
      "AI-generált marketing tartalmak (social media posztok, kampányok)",
      "Email marketing automatizálás",
      "Email feliratkozási formok"
    ],
    items: [
      "Digitális termékek (e-könyvek, sablonok, kurzusok)",
      "Digitális tartalmak (videó, audió, zene stb.)",
      "Online konzultációk és mentoring",
      "Személyre szabott videó üzenetek",
      "Webinárium és workshop jegyek",
      "Előfizetéses exkluzív tartalom",
      "Chat és üzenetküldő szolgáltatások",
      "Coaching és tanácsadó szolgáltatások",
      "Közösségi hozzáférés és networking"
    ],
    moreText: "és még sok mást – folyamatosan bővítjük szolgáltatásainkat.",
    freeExtras: [],
    starterExtras: [],
    growthExtras: [
      { text: "Saját domain", icon: "Globe" },
      { text: "Korlátlan munkatárs kezelés", icon: "UserCheck" }
    ],
    proExtras: [],
    eliteExtras: [
      { text: "Közönség-elemzés", icon: "Users" },
      { text: "Konverziókövetés", icon: "Target" },
      { text: "Tartalom-teljesítmény", icon: "Activity" },
      { text: "AI-növekedési javaslatok", icon: "Sparkles" }
    ],
    vipExtras: [
      { text: "Teljesen egyedi árazás", icon: "BadgePercent" },
      { text: "Dedikált account manager", icon: "UserCheck" },
      { text: "24/7 elsőbbségi támogatás", icon: "Headphones" }
    ]
  },
  packages: {
    starter: {
      name: "Starter",
      subtitle: "Kezdd el most, fizess csak ha keresel"
    },
    growth: {
      name: "Growth", 
      subtitle: "Kezdő alkotóknak"
    },
    pro: {
      name: "Pro",
      subtitle: "Profi alkotóknak"
    },
    vip: {
      name: "Ultimate",
      subtitle: "Nagyon sikeres alkotóknak",
      contactButton: "Vedd fel velünk a kapcsolatot"
    }
  },
  features: {
    title: "Készítsd el a weboldalad és növeld bevételeid\nAI eszközökkel – ezt adja neked a Bespire",
    items: [
      {
        title: "Weboldal-építő",
        description: "Nincs szükséged technológiai tudásra, AI segítségével könnyedén és gyorsan készítheted el egyedi oldalad.",
        icon: "Globe"
      },
      {
        title: "AI eszközök",
        description: "Intelligens tartalomjavaslatokkal és elemzésekkel segítjük munkádat.",
        icon: "Sparkles"
      },
      {
        title: "Nemzetközi fizetési rendszer",
        description: "Biztonságos és széleskörű fizetési lehetőségeket biztosítunk.",
        icon: "CreditCard"
      },
      {
        title: "Helyi nyelvek és pénznemek",
        description: "Termékeidet a világ bármelyik országában értékesítheted.",
        icon: "Banknote"
      },
      {
        title: "Marketing funkciók",
        description: "Promóciós és forgalomnövelő megoldásaink segítenek a növekedésben.",
        icon: "TrendingUp"
      },
      {
        title: "Számlázás és ÁFA kezelés",
        description: "100%-ban automatizált számlázás és nemzetközi ÁFA kezelés minden európai ország adózási szabályinak megfelelően.",
        icon: "FileText"
      }
    ]
  },
  cta: {
    button: "Csatlakozz most",
    subtitle: "A regisztráció ingyenes, és már ma értékesítheted termékeidet."
  },
  comparison: {
    title: "Hasonlítsd össze, hogy mennyit keresnél máshol és mennyit a Bespire platformján.",
    competitors: [
      {
        name: "Hagyományos platformok",
        monthlyFee: "€20–€250",
        commission: "5–15%",
        hiddenCosts: "Van"
      },
      {
        name: "Marketplace",
        monthlyFee: "Ingyenes",
        commission: "20–30%",
        hiddenCosts: "Van"
      }
    ],
    labels: {
      monthlyFee: "Havi díj",
      commission: "Jutalék",
      hiddenCosts: "Rejtett költségek",
      best: "LEGJOBB",
      bespire: "Bespire",
      simpleDescription: "Az egyszerű megoldás",
      traditionalDescription: "Hagyományos megoldás",
      startNow: "Kezdés most",
      zero: "€0",
      none: "Nincs"
    }
  },
  trust: {
    title: "Mi akkor növekszünk, amikor te is",
    subtitle: "Csatlakozz több száz alkotóhoz, akik a Bespire-ben bíznak",
    button: "Kezdd el most ingyen",
    noFees: "Nincs havi díj, nincs rejtett költség",
    backgroundAlt: "Bizalom szekció háttérkép"
  },
  calculator: {
    title: "Számold ki a költségeidet",
    subtitle: "Tudd meg pontosan, hogy mennyit költenél a Bespire platformon",
    monthlyRevenue: "Várt havi bruttó bevétel",
    currency: "Ft",
    revenueDescription: "Írd be, hogy mennyi havi bruttó bevétellel számolsz",
    vatStatus: "ÁFA kötelezettség",
    payVat: "Fizetek ÁFA-t (27%)",
    noVat: "Nem fizetek ÁFA-t",
    vatSubject: "Áfa alanynak minősülsz",
    vatNonSubject: "Kisadózó vagy vagy alatt vagy a határértéknek",
    breakdown: "Havi költségeid lebontása",
    grossRevenue: "Bruttó bevétel",
    vat: "ÁFA (27%)",
    vatTooltip: "Ezt automatikusan kezeljük helyetted nemzetközileg is",
    platformFee: "Bespire platform díj (4% + 120 Ft)",
    netRevenue: "Tiszta bevételed",
    vatInfo: "ÁFA kezelés automatikusan",
    vatDescription: "Az ÁFA-t teljes egészében automatikusan kezeljük helyetted nemzetközileg is. Neked nem kell ezzel foglalkoznod - mi intézzük a bevallást, a befizetést és minden adminisztrációt. Te csak a tiszta bevételedet kapod meg.",
    disclaimer: "* A számítás belföldi értékesítés alapján készült, addicionális token felhasználása nélkül"
  },
  faq: {
    title: "Gyakori kérdések",
    subtitle: "Válaszok a leggyakoribb kérdésekre az árazásunkról",
    questions: [
      {
        question: "Mik azok az AI kreditek?",
        answer: "Az AI krediteket a platform intelligens funkcióihoz használhatod: AI asszisztens, tartalom generálás, képelemzés, termékkínálat optimalizálás és egyéb automatizálási funkciók. A Starter csomag 50 egyszeri kreditet tartalmaz. A Growth csomagban 125-1100 havi kreditet kapsz attól függően, hogy melyik AI kredit szintet választod. Az Ultimate csomag AI-asszisztenst a napi munkádhoz biztosít."
      },
      {
        question: "Mi történik, ha elfogynak a havi AI kreditjeim?",
        answer: "A Starter csomagban az 50 kredit egyszeri, ha elfogy, magasabb csomagra kell váltanod. A Growth csomagban a havi kreditjeid automatikusan megújulnak minden hónap elején - vagy megvárod a feltöltést, vagy magasabb AI kredit szintet választasz a csomagodon belül. Az Ultimate csomagban AI-asszisztenst a napi munkádhoz használhatsz."
      },
      {
        question: "Mennyi ideig érvényesek a kreditek?",
        answer: "A Starter csomag 50 egyszeri kreditje felhasználásig érvényes. A Growth csomag havi kreditjei minden hónap elején automatikusan feltöltődnek a választott kredit szintednek megfelelően (125-1100 kredit). Az előző hónapban fel nem használt kreditek nem vihetők át a következő hónapra."
      },
      {
        question: "Van rejtett díj vagy egyéb költség?",
        answer: "Nincs. Mindkét csomag esetén ugyanaz a jutalék: 4% + 120 Ft fix díj, de csak akkor, ha rajtunk keresztül fizet az ügyfél. A Starter csomag teljesen ingyenes, nincs havi díj. A Growth csomagnál van havi előfizetési díj (€19.9-€89.9 a választott AI kredit szinttől függően), amiért cserébe automatikus havi AI krediteket és profi funkciókat (csapatkezelés, multi-lokáció, részletes riportok) kapsz. Nincsenek setup díjak, rejtett költségek vagy meglepetések."
      },
      {
        question: "Hogyan számolódik a jutalék?",
        answer: "A jutalék minden értékesítésed bruttó összegére vonatkozik (az ÁFA levonása előtti összeg), de csak akkor, ha rajtunk keresztül fizet az ügyfél. Mindkét csomagban ugyanaz: 4% + 120 Ft kerül levonásra minden értékesítés után. Az ÁFA kezelést automatikusan intézzük helyetted. Ha közvetlenül te kezeled a fizetést, nincs jutalék."
      },
      {
        question: "Mikor érdemes magasabb csomagra váltani?",
        answer: "A Growth csomag akkor éri meg, ha rendszeresen használod az AI funkciókat és/vagy szükséged van a profi funkciókra (csapatkezelés, multi-lokáció, részletes riportok, törzsvásárlói program). A jutalék mindkét csomagban ugyanannyi (4% + 120 Ft), de a Growth csomaggal automatikus havi AI krediteket kapsz (125-1100 kredit), így nem kell mindig külön vásárolnod. Ha intenzíven használod az AI-t, a Growth csomag gyorsan megtérül."
      },
      {
        question: "Tudok-e bármikor csomagot váltani?",
        answer: "Igen, bármikor válthatsz alacsonyabb vagy magasabb csomagra. Ha magasabb csomagra váltasz, azonnal élvezheted az előnyöket (alacsonyabb jutalék, több AI kredit). Ha alacsonyabb csomagra váltasz, a módosítás a következő számlázási időszak kezdetén lép életbe."
      },
      {
        question: "Mire jó az Ultimate csomag?",
        answer: "Az Ultimate csomag nagyon sikeres alkotóknak készült, akik nagy forgalmat bonyolítanak. Egyedi árképzést, AI-asszisztenst a napi munkádhoz, dedikált account managert, 24/7 prioritás támogatást és API integrációt biztosítunk. A részletekért vedd fel velünk a kapcsolatot."
      },
      {
        question: "Mikor kapom meg a kifizetésemet?",
        answer: "A bevételeid automatikusan a bankszámládra kerülnek a helyi banki szabályozásoknak megfelelően, általában 2-5 munkanapon belül. Az ÁFA-t és a jutalékot már levontuk, így csak a tiszta bevételedet kapod meg."
      },
      {
        question: "Milyen fizetési módokat fogadtok el?",
        answer: "A havi előfizetést bankkártyával fizetheted. Vásárlóid számára pedig széles körű fizetési lehetőségeket biztosítunk: bankkártyák, PayPal, banki átutalás és több mint 20 helyi fizetési mód világszerte."
      }
    ]
  },
  additionalTokens: {
    title: "Kiegészítő AI Kreditek",
    description: "Ha elfogynak a havi creditjeid akkor egyszeri vásárlásként mindig tudsz hozzávenni",
    explanation: "Ezek a csomagok NEM önálló előfizetések - csak akkor vásárolhatod meg őket, ha már van aktív előfizetésed és elfogytak a havi kreditjeid. Az AI krediteket weboldal készítésére használhatod az AI asszisztenssel.",
    subtitle: "A kreditek a vásárlás dátumától számított 6 hónapig érvényesek.",
    button: "Csomag Kiválasztása",
    noExtra: "Nem kérek plusz creditet",
    packages: [
      { 
        credits: 100, 
        price: "9,90",
        label: "credit"
      },
      { 
        credits: 300, 
        price: "29,90",
        label: "credit"
      },
      { 
        credits: 500, 
        price: "44,90",
        label: "credit",
        popular: true,
        badge: "Legnépszerűbb"
      },
      { 
        credits: 1000, 
        price: "89,90",
        label: "credit"
      }
    ],
    priceLabel: "ÁFÁ-val"
  },
  finalCta: {
    title: "Csatlakozz több száz alkotóhoz",
    subtitle: "Kezdj el ma eladni egyszerű, átlátható árazásunkkal. Nincs setup díj.",
    button: "Kezdd el most",
    features: "Kezdj el ingyen • Nincs szükség bankkártyára • Csak 4% + 120 Ft jutalék"
  },
  footer: {
    features: "Funkciók",
    support: "Támogatás",
    newsletter: "Hírlevél",
    newsletterDescription: "Iratkozz fel a hírlevélre és értesülj elsőként az újdonságokról!",
    emailPlaceholder: "Add meg az email címed",
    subscribe: "Feliratkozás",
    affiliateProgram: "Ajánlói program",
    copyright: "© 2025 Bespire. Minden jog fenntartva.",
    madeWithLove: "Készítve ❤️-vel alkotóknak",
    systemStatus: "Rendszer állapot: Működik",
    links: {
      products: "Mit árulhatsz?",
      comparison: "Összehasonlítás",
      faq: "GYIK",
      partnerProgram: "Partner program",
      getStarted: "Kezdjük el",
      contact: "Kapcsolat",
      privacy: "Adatvédelem",
      terms: "ÁSZF",
      aboutUs: "Rólunk"
    },
    alerts: {
      privacy: "Adatvédelmi irányelvek hamarosan!",
      terms: "Általános szerződési feltételek hamarosan!",
      socialClick: "Megnyitás:",
      newsletter: "Hírlevél feliratkozás:"
    },
    socialPlatforms: {
      instagram: "instagram",
      twitter: "twitter", 
      email: "email"
    }
  }
};